function emptyStringToUndefined(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return undefined;
  }
  return value;
}

function currencyStringToNumber(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return undefined;
  }

  if (typeof originalValue === 'string') {
    value = originalValue.replace(/\D/g, '');
    return Number(value);
  }

  return value;
}

export {emptyStringToUndefined, currencyStringToNumber};


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/EmptyStringToUndefined.js